import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company, EmployeeCode } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function listPayUnit(date, expenseCode) {
    let url = 'expenseAccount/payUnits?' + objectToQueryString({ company: Company(), userCode: UserCode(), date: date, expenseCode: expenseCode, token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let payUnits = response.payUnits;

                //savePayUnits(payUnits);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortPayUnits(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.englishDescription.toLowerCase() : a.frenchDescription.toLowerCase()
        const nameB = IsEnglish() ? b.englishDescription.toLowerCase() : b.frenchDescription.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortPayUnitsByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.unitPayCode
        const nameB = b.unitPayCode
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

function savePayUnits(config) {
    localStorage.setItem('payUnits', JSON.stringify(config));
}